import React, { Component } from "react";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import { message, Spin } from "antd";
import Bridge from "./utils/Bridge";
import { speech_demographics_form_type } from "./utils/consts";

// asymptomatic study
import PersonalInfo from "./screens/basicdetails/PersonalInfo";
import GenderInfo from "./screens/basicdetails/GenderInfo";
import LanguageEducation from "./screens/basicdetails/LanguageEducation";
import PhysicalCharachteristics from "./screens/basicdetails/PhysicalCharachteristics";
import MedicalHistory from "./screens/basicdetails/MedicalHistory";
import MedicalConditions from "./screens/basicdetails/MedicalConditions";
import FamilyHistory from "./screens/basicdetails/FamilyHistory";
import AdditionalHealthInfo from "./screens/basicdetails/AdditionalHealthInfo";
import RecentHealthEvents from "./screens/basicdetails/RecentHealthEvents";
import GeneticTesting from "./screens/basicdetails/GeneticTesting";

// ecas study
import EcasPersonalInfo from "./screens/ecasBasicDetails/PersonalInfo";
import EcasGenderInfo from "./screens/ecasBasicDetails/GenderInfo";
import EcasLanguageEducation from "./screens/ecasBasicDetails/LanguageEducation";
import EcasPhysicalCharachteristics from "./screens/ecasBasicDetails/PhysicalCharachteristics";
import EcasMedicalHistory from "./screens/ecasBasicDetails/MedicalHistory";
import EcasMedicalConditions from "./screens/ecasBasicDetails/MedicalConditions";
import EcasFamilyHistory from "./screens/ecasBasicDetails/FamilyHistory";
import EcasAdditionalHealthInfo from "./screens/ecasBasicDetails/AdditionalHealthInfo";
import EcasRecentHealthEvents from "./screens/ecasBasicDetails/RecentHealthEvents";
import EcasGeneticTesting from "./screens/ecasBasicDetails/GeneticTesting";
import EcasSymptomOnsetForm from "./screens/ecasBasicDetails/SymptomOnsetForm";

// speech study
import SpeechNonAlsUsers from "./screens/speech/demographicsComponents/NonAlsUsersForm";
import SpeechDateOfBirth from "./screens/speech/demographicsComponents/DateOfBirthForm";
import SpeechEthnicityRace from "./screens/speech/demographicsComponents/EthnicityRaceForm";
import SpeechLanguageAndEducation from "./screens/speech/demographicsComponents/LanguageAndEducationForm";
import SpeechHandnessSmokingHistory from "./screens/speech/demographicsComponents/HandnessSmokingHistoryForm";
import SpeechAllergiesAndPrescriptions from "./screens/speech/demographicsComponents/AllergiesAndPrescriptionsForm";
import SpeechMedicalHistory from "./screens/speech/demographicsComponents/MedicalHistoryForm";
import SpeechDiagnosis from "./screens/speech/demographicsComponents/DiagnosisForm";
import SpeechSymptomOnset from "./screens/speech/demographicsComponents/SymptomOnsetForm";
import SpeechFamilyHistory from "./screens/speech/demographicsComponents/FamilyHistoryForm";

// als
import LEAlsPersonalInfo from "./screens/leStudy/demographicsComponents/als/PersonalInfo";
import LEAlsSymptomOnsetForm from "./screens/leStudy/demographicsComponents/als/SymptomOnsetForm";
import LEAlsGenderInfo from "./screens/leStudy/demographicsComponents/als/GenderInfo";
import LEAlsLanguageEducation from "./screens/leStudy/demographicsComponents/als/LanguageEducation";
import LEAlsMedicalHistory from "./screens/leStudy/demographicsComponents/als/MedicalHistory";

// controls
import LEControlsPersonalInfo from "./screens/leStudy/demographicsComponents/controls/PersonalInfo";
import LEControlsGenderInfo from "./screens/leStudy/demographicsComponents/controls/GenderInfo";
import LEControlsLanguageEducation from "./screens/leStudy/demographicsComponents/controls/LanguageEducation";
import LEControlsMedicalHistory from "./screens/leStudy/demographicsComponents/controls/MedicalHistory";

import { RESEARCH_TYPE } from "./utils/consts";
import { logEvent } from "./utils/analytics";
import englishJson from "./utils/language/leStudy/english.json";
import spanishJson from "./utils/language/leStudy/spanish.json";

export default class BasicDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active_step: 1,
      is_loaded: false,
      loading: false,
      is_non_als_user: false,
    };
  }
  componentDidMount() {
    if (RESEARCH_TYPE == "modality.ai") {
      this.get_demographic_details();
    } else if (RESEARCH_TYPE == "LE Study") {
      this.get_le_demographic_details();
    } else if (RESEARCH_TYPE == "ECAS Study") {
      this.get_ecas_demographic_details();
    }
  }
  selectUserType = (param) => {
    this.setState({
      active: param,
    });
  };
  get_le_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics.le_study
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          console.log("response", response);
          let present_sections = [];
          for (let item of response.data) {
            present_sections.push(item.field);
          }
          console.log(
            "ap_relation_to_als",
            localStorage.getItem("ap_relation_to_als")
          );

          if (localStorage.getItem("ap_relation_to_als") == "Living with ALS") {
            if (!present_sections.includes("FirstName")) {
              this.setState({ active_step: 1 });
              return;
            }
            if (!present_sections.includes("Date Of Symptom Onset")) {
              this.setState({ active_step: 2 });
              return;
            }
            if (!present_sections.includes("Physical sex at birth")) {
              this.setState({ active_step: 3 });
              return;
            }
            if (!present_sections.includes("Is English your first language")) {
              this.setState({ active_step: 4 });
              return;
            }
            if (!present_sections.includes("ALS Drug History")) {
              this.setState({ active_step: 5 });
              return;
            }
          } else {
            console.log("inside");
            console.log("present_sections", present_sections);
            if (!present_sections.includes("FirstName")) {
              this.setState({ active_step: 1 });
              return;
            }
            if (!present_sections.includes("Physical sex at birth")) {
              this.setState({ active_step: 3 });
              return;
            }
            if (!present_sections.includes("Is English your first language")) {
              this.setState({ active_step: 4 });
              return;
            }
            if (!present_sections.includes("Neurological Disease")) {
              this.setState({ active_step: 5 });
              return;
            }
          }
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  get_ecas_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics.ecas_study
      .get(params)
      .then((response) => {
        if (response.status == "1") {
          const data = response.data;
          const getFieldValue = (fieldName) => {
            const item = data.find((x) => x.field === fieldName);
            return item ? item.value : null;
          };
          const isSectionComplete = (
            submittedField,
            saveTypeField,
            fallbackField
          ) => {
            const submitted = getFieldValue(submittedField);
            if (submitted !== null) {
              return (
                submitted == "1" &&
                getFieldValue(saveTypeField) != "Save for Later"
              );
            }
            return getFieldValue(fallbackField) !== null;
          };

          const sections = [
            {
              step: 1,
              submitted: "Is Personal Information Fields Submitted",
              saveType: "Personal Information Save Type",
              fallback: "FirstName",
            },
            {
              step: 2,
              submitted: "Is Symptom Onset Fields Submitted",
              saveType: "Symptom Onset Save Type",
              fallback: "Date of Diagnosis",
            },
            {
              step: 3,
              submitted: "Is Gender Race Ethnicity Fields Submitted",
              saveType: "Gender Race Ethnicity Save Type",
              fallback: "Physical sex at birth",
            },
            {
              step: 4,
              submitted: "Is Language Education Fields Submitted",
              saveType: "Language Education Save Type",
              fallback: "Is English your first language?",
            },
            {
              step: 5,
              submitted: "Is Physical Characteristics Fields Submitted",
              saveType: "Physical Characteristics Save Type",
              fallback: "Height In Inches",
            },
            {
              step: 6,
              submitted: "Is Medical History Fields Submitted",
              saveType: "Medical History Save Type",
              fallback: "Do you have any allergies?",
            },
            {
              step: 7,
              submitted: "Is Family History Fields Submitted",
              saveType: "Family History Save Type",
              fallback:
                "Do you have a positive family history for ALS or any other neurodegenerative disease",
            },
            {
              step: 8,
              submitted: "Is Additional Health Info Fields Submitted",
              saveType: "Additional Health Info Save Type",
              fallback: "Are you on any medication?",
            },
          ];

          for (const section of sections) {
            if (
              !isSectionComplete(
                section.submitted,
                section.saveType,
                section.fallback
              )
            ) {
              this.setState({ active_step: section.step });
              return;
            }
          }
          this.setState({ active_step: 8 });
        }
      })
      .catch(() => {});
  };
  get_demographic_details = () => {
    this.setState({ loading: true });
    let params =
      "?participants_accounts_id=" +
      localStorage.getItem("ap_participants_accounts_id") +
      "&type=" +
      speech_demographics_form_type.non_als_user;
    Bridge.demographics.speech
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          let present_sections = response.present_sections;
          let is_non_als_user = response.is_non_als_user;
          this.setState({
            is_loaded: true,
            loading: false,
            is_non_als_user: is_non_als_user,
          });
          if (present_sections.length == 0 && is_non_als_user == true) {
            this.setState({ active_step: 1 });
          } else if (present_sections.length == 0 && is_non_als_user == false) {
            this.setState({ active_step: 8 });
          } else if (!present_sections.includes("Date of Birth and Sex")) {
            this.setState({ active_step: 2 });
          } else if (!present_sections.includes("Ethnicity and Race")) {
            this.setState({ active_step: 3 });
          } else if (!present_sections.includes("Language and Education")) {
            this.setState({ active_step: 4 });
          } else if (
            !present_sections.includes("Handedness and Smoking History")
          ) {
            this.setState({ active_step: 5 });
          } else if (
            !present_sections.includes("Allergies and Prescriptions")
          ) {
            this.setState({ active_step: 6 });
          } else if (!present_sections.includes("Medical History")) {
            this.setState({ active_step: 7 });
          } else if (
            !present_sections.includes("Diagnosis") &&
            is_non_als_user == true
          ) {
            this.setState({ active_step: 10 });
          } else if (
            !present_sections.includes("Diagnosis") &&
            is_non_als_user == false
          ) {
            this.setState({ active_step: 8 });
          } else if (!present_sections.includes("Symptom Onset")) {
            this.setState({ active_step: 9 });
          } else if (!present_sections.includes("Family History")) {
            this.setState({ active_step: 10 });
          }
        } else {
          this.setState({ loading: true });
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  continue = () => {
    if (!this.state.active) {
      message.warning("Please select account");
      return;
    }
  };
  onChange = (date, dateString) => {
    this.setState({
      date_of_birth: date,
    });
  };
  set_active_step = (step) => {
    const sectionMaps = {
      "modality.ai": {
        1: "non_als_users", 2: "date_of_birth", 3: "ethnicity_race",
        4: "language_education", 5: "handedness_smoking_history",
        6: "allergies_prescriptions", 7: "medical_history",
        8: "diagnosis", 9: "symptom_onset", 10: "family_history",
      },
      "Asymptomatic Study": {
        1: "personal_info", 2: "gender_race_ethnicity",
        3: "language_education", 4: "physical_characteristics",
        5: "medical_history", 6: "family_history",
        7: "additional_health_info", 9: "genetic_testing",
      },
      "ECAS Study": {
        1: "personal_info", 2: "symptom_onset", 3: "gender_race_ethnicity",
        4: "language_education", 5: "physical_characteristics",
        6: "medical_history", 7: "family_history", 8: "additional_health_info",
      },
      "LE Study": {
        1: "personal_info", 2: "symptom_onset", 3: "gender_race_ethnicity",
        4: "language_education", 5: "medical_history",
      },
    };
    const section = (sectionMaps[RESEARCH_TYPE] || {})[step];
    if (section) logEvent("section_viewed", { section });
    this.setState({ active_step: step });
  };
  render() {
    const formData = RESEARCH_TYPE == "LE Study" ? (this.props.language == "English" ? englishJson : spanishJson) : englishJson;
    return (
      <div>
        <Header />
        <div className="main-content demographics-section-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-11 m-auto">
                <div className="demographic-single-section">
                  <a href="/dashboard" className="back-arrow width-fit-content">
                    <box-icon
                      name="chevron-left"
                      color="#fff"
                      style={{ position: "relative", top: 1 }}
                    ></box-icon>
                    {formData.page.backButtonTextDashboard}
                  </a>
                  {RESEARCH_TYPE == "modality.ai" && (
                    <>
                      <Spin spinning={this.state.loading}>
                        {this.state.loading == true && (
                          <div style={{ height: 100 }}>
                            <h3 className="text-center">Loading...</h3>
                          </div>
                        )}
                        {this.state.is_loaded == true && (
                          <>
                            {this.state.active_step == 1 && (
                              <SpeechNonAlsUsers
                                set_active_step={this.set_active_step}
                                is_update={false}
                                is_non_als_user={this.state.is_non_als_user}
                              />
                            )}
                            {this.state.active_step == 2 && (
                              <SpeechDateOfBirth
                                set_active_step={this.set_active_step}
                                is_update={false}
                                is_non_als_user={this.state.is_non_als_user}
                              />
                            )}
                            {this.state.active_step == 3 && (
                              <SpeechEthnicityRace
                                set_active_step={this.set_active_step}
                                is_update={false}
                                is_non_als_user={this.state.is_non_als_user}
                              />
                            )}
                            {this.state.active_step == 4 && (
                              <SpeechLanguageAndEducation
                                set_active_step={this.set_active_step}
                                is_update={false}
                                is_non_als_user={this.state.is_non_als_user}
                              />
                            )}
                            {this.state.active_step == 5 && (
                              <SpeechHandnessSmokingHistory
                                set_active_step={this.set_active_step}
                                is_update={false}
                                is_non_als_user={this.state.is_non_als_user}
                              />
                            )}
                            {this.state.active_step == 6 && (
                              <SpeechAllergiesAndPrescriptions
                                set_active_step={this.set_active_step}
                                is_update={false}
                                is_non_als_user={this.state.is_non_als_user}
                              />
                            )}
                            {this.state.active_step == 7 && (
                              <SpeechMedicalHistory
                                set_active_step={this.set_active_step}
                                is_update={false}
                                is_non_als_user={this.state.is_non_als_user}
                              />
                            )}
                            {this.state.active_step == 8 && (
                              <SpeechDiagnosis
                                set_active_step={this.set_active_step}
                                is_update={false}
                                is_non_als_user={this.state.is_non_als_user}
                              />
                            )}
                            {this.state.active_step == 9 && (
                              <SpeechSymptomOnset
                                set_active_step={this.set_active_step}
                                is_update={false}
                                is_non_als_user={this.state.is_non_als_user}
                              />
                            )}
                            {this.state.active_step == 10 && (
                              <SpeechFamilyHistory
                                set_active_step={this.set_active_step}
                                is_update={false}
                                is_non_als_user={this.state.is_non_als_user}
                              />
                            )}
                          </>
                        )}
                      </Spin>
                    </>
                  )}
                  {RESEARCH_TYPE == "Asymptomatic Study" && (
                    <>
                      {this.state.active_step == "1" && (
                        <PersonalInfo
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == "2" && (
                        <GenderInfo
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == "3" && (
                        <LanguageEducation
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == "4" && (
                        <PhysicalCharachteristics
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == "5" && (
                        <MedicalHistory
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {/* {this.state.active_step == "6" && (
                        <MedicalConditions
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )} */}
                      {this.state.active_step == "6" && (
                        <FamilyHistory
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == "7" && (
                        <AdditionalHealthInfo
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {/* {this.state.active_step == "8" && (
                        <RecentHealthEvents
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )} */}
                      {this.state.active_step == "9" && (
                        <GeneticTesting
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                    </>
                  )}
                  {RESEARCH_TYPE == "ECAS Study" && (
                    <>
                      {this.state.active_step == 1 && (
                        <EcasPersonalInfo
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == 2 && (
                        <EcasSymptomOnsetForm
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == 3 && (
                        <EcasGenderInfo
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == 4 && (
                        <EcasLanguageEducation
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == 5 && (
                        <EcasPhysicalCharachteristics
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == 6 && (
                        <EcasMedicalHistory
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}                      
                      {this.state.active_step == 7 && (
                        <EcasFamilyHistory
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {this.state.active_step == 8 && (
                        <EcasAdditionalHealthInfo
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )}
                      {/* {this.state.active_step == "8" && (
                        <RecentHealthEvents
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )} */}
                      {/* {this.state.active_step == "9" && (
                        <EcasGeneticTesting
                          set_active_step={this.set_active_step}
                          is_update={false}
                        />
                      )} */}
                    </>
                  )}
                  {RESEARCH_TYPE == "LE Study" && (
                    <>
                      {this.state.active_step == 1 && (
                        <div>
                          {localStorage.getItem("ap_relation_to_als") ==
                          "Healthy control" ? (
                            <LEControlsPersonalInfo
                              set_active_step={this.set_active_step}
                              is_update={false}
                              language={this.props.language}
                            />
                          ) : (
                            <LEAlsPersonalInfo
                              set_active_step={this.set_active_step}
                              is_update={false}
                              language={this.props.language}
                            />
                          )}
                        </div>
                      )}
                      {this.state.active_step == 2 && (
                        <div>
                          {localStorage.getItem("ap_relation_to_als") ==
                            "Living with ALS" && (
                            <LEAlsSymptomOnsetForm
                              set_active_step={this.set_active_step}
                              is_update={false}
                              language={this.props.language}
                            />
                          )}
                        </div>
                      )}
                      {this.state.active_step == 3 && (
                        <div>
                          {localStorage.getItem("ap_relation_to_als") ==
                          "Healthy control" ? (
                            <LEControlsGenderInfo
                              set_active_step={this.set_active_step}
                              is_update={false}
                              language={this.props.language}
                            />
                          ) : (
                            <LEAlsGenderInfo
                              set_active_step={this.set_active_step}
                              is_update={false}
                              language={this.props.language}
                            />
                          )}
                        </div>
                      )}
                      {this.state.active_step == 4 && (
                        <div>
                          {localStorage.getItem("ap_relation_to_als") ==
                          "Healthy control" ? (
                            <LEControlsLanguageEducation
                              set_active_step={this.set_active_step}
                              is_update={false}
                              language={this.props.language}
                            />
                          ) : (
                            <LEAlsLanguageEducation
                              set_active_step={this.set_active_step}
                              is_update={false}
                              language={this.props.language}
                            />
                          )}
                        </div>
                      )}
                      {this.state.active_step == 5 && (
                        <div>
                          {localStorage.getItem("ap_relation_to_als") ==
                          "Healthy control" ? (
                            <LEControlsMedicalHistory
                              set_active_step={this.set_active_step}
                              is_update={false}
                              language={this.props.language}
                            />
                          ) : (
                            <LEAlsMedicalHistory
                              set_active_step={this.set_active_step}
                              is_update={false}
                              language={this.props.language}
                            />
                          )}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
